<template>
  <VModal name="addedit-webhook-modal" :loading="loading" v-if="webhook">
    <template v-slot:header>
      <h2 class="o-modal__box__header">{{ $t('companySettings.developer.webhooks.edit') }}</h2>
    </template>
    <template v-slot:content>
      <VForm :onSubmit="validateForm" data-vv-scope="webhook" ref="form">
        <div slot="row">
          <VGrid>
            <div slot="gridItem" type="12">
              <b>{{ $t('companySettings.developer.webhooks.url') }}</b>
              <VInput
                type="text"
                v-validate="'required'"
                data-vv-name="url"
                :data-vv-as="$t('companySettings.developer.webhooks.url')"
                v-model="webhook.url"
                data-vv-scope="webhook"
                :class="{ 'a-input--error': errors.has('webhook.url') }"
                data-hj-suppress
                data-ec="webhooks_add_edit_webhooks_modal"
                data-et="add_webhook_input"
              />
              <VMessage
                type="error"
                subtype="basic"
                v-show="errors.has('webhook.url')"
              >
                <template v-slot:icon>
                  <XMarkIcon />
                </template>
                <template v-slot:text>
                  {{ errors.first('webhook.url') }}
                </template>
              </VMessage>
            </div>

            <div slot="gridItem" type="6" v-if="!isNew">
              <b>{{ $t('companySettings.developer.webhooks.failedCount') }}</b>
              {{webhook.failed_count}}

              <template v-if="isSuspended">
                <b class="mt-2">{{ $t('companySettings.developer.webhooks.suspended') }}</b>
                <ToggleInput
                  v-model="suspendedToggle"
                  :hasError="true"
                  data-ec="webhooks_add_edit_webhooks_modal"
                  data-et="unsuspend_button"
                />
                <p class="mt-1">{{ $t('companySettings.developer.webhooks.isSuspendedDescription') }}</p>
              </template>
            </div>

            <div slot="gridItem" type="6" v-if="!isNew">
              <b>{{ $t('companySettings.developer.webhooks.type') }}</b>
              <span v-if="!isNew">
                {{ $t(`companySettings.developer.webhooks.types.${webhook.type}`) }}
              </span>
            </div>

            <div slot="gridItem" type="6" v-if="isNew">
              <b>{{ $t('companySettings.developer.webhooks.type') }}</b>
              <ElSelect size="large" v-model="webhook.type">
                <ElOption
                  v-for="(value, name) in webhookTypes"
                  :value="name"
                  :key="name"
                  :label="$t(`companySettings.developer.webhooks.types.${name}`)"
                  data-ec="webhooks_add_edit_webhooks_modal"
                  :data-et="`select_webhook_${name}`"
                />
              </ElSelect>
            </div>
          </VGrid>
        </div>

        <div slot="formButtons" type="right">
          <VButton type="success" subtype="submit" data-ec="webhooks_add_edit_webhooks_modal" data-et="save_button">
            <SaveIcon />
            <span>{{ $t('functional.save')}}</span>
          </VButton>
        </div>
      </VForm>
    </template>
  </VModal>
</template>

<script>
import engb from '@/locales/en_GB.json';
import VButton from '@/components/deprecated/atoms/Button.vue';
import VInput from '@/components/deprecated/atoms/Input.vue';
import VMessage from '@/components/deprecated/atoms/Message.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import VGrid from '@/components/deprecated/organisms/Grid.vue';
import VModal from '@/components/deprecated/organisms/Modal.vue';
import ToggleInput from '@/components/tailwind/forms/ToggleInput.vue';
import { SaveIcon, XMarkIcon } from '@/components/icons/fontIcons';

export default {
  name: 'AddEditWebhookModal',
  inject: {
    $validator: '$validator',
  },
  props: {
    item: Object,
  },
  components: {
    VButton,
    ToggleInput,
    VInput,
    VMessage,
    VForm,
    VGrid,
    VModal,
    SaveIcon,
    XMarkIcon,
  },
  watch: {
    // Duplicate copied data in to modal
    item(newItem) {
      this.webhook = JSON.parse(JSON.stringify(newItem));
      this.suspendedToggle = this.isSuspended;
    },
  },
  data() {
    return {
      loading: false,
      showKey: false,
      webhook: {
        url: '',
        type: '',
      },
      suspendedToggle: false,
      webhookTypes: engb.companySettings.developer.webhooks.types,
    };
  },
  computed: {
    isNew() {
      return !this.webhook.id;
    },
    isSuspended() {
      return !!this.webhook.suspended_at;
    },
  },
  methods: {
    validateForm(scope) {
      this.loading = true;
      this.$validator.validateAll(scope).then((validated) => {
        if (!validated) {
          this.loading = false;
          return;
        }
        if (this.isNew) {
          this.$store.dispatch('webhooks/CREATE', this.webhook).then((res) => {
            this.webhook = res.data.data; // Reload this webhook in modal from response data
            this.$bus.$emit('closeModal');
          }).finally(() => {
            this.loading = false;
          });
        } else {
          this.$store.dispatch('webhooks/UPDATE', { ...this.webhook, unsuspend: !this.suspendedToggle || undefined }).then(() => {
            this.$bus.$emit('closeModal');
            this.loading = false;
          }).catch(() => {
            this.loading = false;
          });
        }
      });
    },
  },
};
</script>
